import { render, staticRenderFns } from "./taskFolderList.vue?vue&type=template&id=20b09d50&scoped=true&"
import script from "./taskFolderList.vue?vue&type=script&lang=js&"
export * from "./taskFolderList.vue?vue&type=script&lang=js&"
import style0 from "./taskFolderList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./taskFolderList.vue?vue&type=style&index=1&id=20b09d50&lang=less&scoped=true&"
import style2 from "./taskFolderList.vue?vue&type=style&index=2&id=20b09d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b09d50",
  null
  
)

export default component.exports